module.exports = __webpack_public_path__ + "static/treninky-2.6935513c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/treninky-2.jpg
// module id = 471
// module chunks = 126072307104019